import styled from "styled-components";

export const Container: any = styled.div`
  padding: 0 15px;
  margin: 0 auto;
`;
export const Wrapper: any = styled.div`
  background-color: #fff;
  width: 100%;
  min-height: 100vh;
  max-width: 560px;
  margin: 0 auto;
  padding: 0;
`;
